// viewAudit — تدقيق القراءة (3.4.59): يسجّل عرض صفحة/سجلّ حسّاس في access_audit_logs
// عبر POST /audit/log (الخادم يلتقط IP/الفاعل/المسار). best-effort — لا يكسر الصفحة إن فشل.
import { useEffect } from 'react';
import api from '../services/api';

export function logView(entityType, entityId = 0, extra) {
  try {
    api.post('/audit/log', {
      entity_type: String(entityType || 'page'),
      entity_id: Number(entityId) || 0,
      action: 'VIEW',
      extra: extra || undefined,
    }).catch(() => {});
  } catch (_) { /* تجاهل */ }
}

// هوك: يسجّل عرض الصفحة مرّة عند التركيب (للصفحات الحسّاسة ماليًّا/أمنيًّا).
export function useViewAudit(entityType, entityId = 0) {
  useEffect(() => {
    logView(entityType, entityId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useViewAudit;
